








import Vue from 'vue';
import Component from 'vue-class-component';

const Setup = Vue.extend({
	name: 'FormError',
	props: {
		error: { type: String, default: '' },
	},
});

@Component
export default class FormError extends Setup {
	public error!: string;
}
